import { signal } from 'services/SignalsService'
import { spinSettings } from 'settings/custom/reels'
import { delay } from 'utils/Delay'

const name = 'SPREADING'

function isValid(item) {
  return item.length
}

async function execute() {
  const spinModel = game.models.SpinModel.get()

  const winModel = game.models.WinModel.get()
  const items = spinModel.matrix
    .flatMap(toPosition)
    .filter(isValid)

  spinModel.matrix = winModel.expendingMatrix
  winModel.winLines = winModel.expendingWinLines
  winModel.linesWin = winModel.expendingWin
  winModel.winType = winModel.expendingWinType
  winModel.expendingWin = 0
  winModel.expendingMatrix = []

  while (items.length) {
    const item = items.shift()
    signal.dispatch('SPREAD-SYMBOL', item)
    await delay(spinSettings.spread.time)
  }

  function toPosition(reel, row) {
    function toXY(item, col) {
      return item === winModel.expendingMatrix[row][col]
        ? []
        : [row, col]
    }

    return reel.map(toXY)
  }
}

export function getSpreadingAction() {
  return {
    name,
    execute,
  }
}
